import React, { useState } from "react"
import styled from "styled-components"
import { Input, ButtonLink, H2 } from "../general/GeneralStyles"
import axios from "axios"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ModalBG = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
`

const Modal = styled.div`
  background: #fff;
  padding: 40px 40px;
  width: 380px;
  height: auto;
  position: absolute;
  text-align: center;
  /* display: flex; */
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  ${ButtonLink} {
    margin-top: 20px;
  }
`

const Close = styled.span`
  position: absolute;
  right: 20px;
  top: 20px;
  font-size: 1.5rem;
  font-family: ${props => props.theme.primaryFont};
  font-weight: bold;
  cursor: pointer;
  color: ${props => props.theme.primaryColor};
`

const ForgotPasswordModal = props => {
  const [email, setEmail] = useState("")
  const [emailSent, setEmailSent] = useState(false)

  const requestEmail = () => {
    axios
      .post("/api/password/create", { email: email })
      .then(response => {
        console.log(response.data)
        setEmailSent(true)
      }).catch(error => {
        alert("Something went wrong please try again.")
      })
  }

  return (
    <ModalBG>
      <Modal>
        {!emailSent ? (
          <>
            {" "}
            <H2>Reset Your Password</H2>
            <Input
              type="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
            <ButtonLink onClick={requestEmail}>Send me an Email</ButtonLink>
          </>
        ) : (
          <>
            <H2>You will receive an email with instructions</H2>
          </>
        )}
        <Close onClick={() => props.onClick(false)}>
          <FontAwesomeIcon icon="times" />
        </Close>
      </Modal>
    </ModalBG>
  )
}

export default ForgotPasswordModal
